import { Dropdown, DropdownRef, Input, Menu, Tooltip } from '@recruit-robin/robin-theme/web-components';
import { PuzzlePiece_01 } from '@recruit-robin/robin-theme/web-icons';
import { useContext, useRef, useState } from 'react';

import type { Vacancy } from 'clients/AutoCompleteClient/types';

import { IndeedTooltip } from 'components/ui/molecules/VacancyList/components/IndeedTooltip/IndeedTooltip';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { getVacancyName } from 'utils/vacancyEnrichedUtils';
import { useCreateEnrichedVacancy } from '../../../../hooks/useCreateEnrichedVacancy';
import { useStyles } from './CreateFromTemplate.styles';
import { useVacancyTemplateList } from './useVacancyTemplateList';

export const CreateFromTemplate = () => {
  const classes = useStyles();
  const { dictionary, language } = useContext(LocalizationContext);
  const [search, setSearch] = useState('');
  const dropdownRef = useRef<DropdownRef>(null);
  const { handleCreateFromTemplate } = useCreateEnrichedVacancy();

  const { list, isLoading } = useVacancyTemplateList(search);

  const handleSelectVacancy = async (vacancy: Vacancy) => {
    dropdownRef.current?.close();

    handleCreateFromTemplate(vacancy);
  };

  return (
    <Dropdown
      ref={dropdownRef}
      placement="bottom-start"
      autoUpdateMenuPosition
      flipMenu={false}
      renderMenu={
        <Menu.Root customCss={classes.menu}>
          {isLoading
            ? Array.from({ length: 4 }).map((_, i) => <Menu.Item.Skeleton key={i} />)
            : list.map((v) => {
                const tooltip =
                  v.type === 'INDEED' && v.originalIndeedJob ? <IndeedTooltip indeedJob={v.originalIndeedJob} /> : null;

                return (
                  <Tooltip
                    key={`${v.db_id}-${v.job_ats_id}-${v.job_indeed_id}-${v.value}`}
                    customCss={classes.tooltip}
                    label={tooltip}
                    zIndex={1000}
                    placement="left"
                    disabled={!tooltip}>
                    <Menu.Item.Root onClick={() => handleSelectVacancy(v)}>{getVacancyName(v)}</Menu.Item.Root>
                  </Tooltip>
                );
              })}
        </Menu.Root>
      }>
      {({ isOpen }) => (
        <Input
          customCss={[
            classes.input,
            isOpen && classes.inputOpen,
            language === 'en' && classes.inputWidthEn,
            language === 'nl' && classes.inputWidthNl,
          ]}
          value={isOpen ? search : dictionary.selectTemplate}
          onInput={(e) => setSearch(e.currentTarget.value)}
          placeholder={dictionary.search}
          startIcon={<PuzzlePiece_01 size={18} />}
        />
      )}
    </Dropdown>
  );
};
